import React from 'react'
import { Row, Col, Form, Input, Button, Select } from 'antd'
import { reqConvertIDs } from '../../api'

const { Option, OptGroup  } = Select

class IdConverter extends React.Component {
    state = {
        output_ids: ''
    }

    formRef = React.createRef()

    onFinish = async (values) => {
        const { input_ids, dataset } = values
        let output_ids = ''

        const convertResult = await reqConvertIDs(input_ids, dataset)
        if (convertResult.code === 0) {
            output_ids = convertResult.data
        }
        output_ids = output_ids.join("\n")

        this.formRef.current.setFieldsValue({
            output_ids: output_ids
        })
    }

    render() {
        return (
            <Form layout="vertical" ref={this.formRef} onFinish={this.onFinish}>
                <Row justify="space-between" align="middle">
                    <Col span={9}>
                        <Form.Item name="input_ids" label="GeneIDs Input"
                            rules={[
                                { required: true }
                            ]}
                        >
                            <Input.TextArea rows="20" placeholder="input geneids here and seprated by new line or comma" allowClear />    
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="dataset" label="Select Dataset"
                            rules={[
                                { required: true }
                            ]}
                        >
                            <Select placeholder="Select dataset" allowClear onChange={this.onDatasetEntryChange}>
                                <OptGroup label="positive">
                                    <Option value="SL2.4__v__SL5.0">SL2.4 vs SL5.0</Option>
                                    <Option value="SL4.0__v__SL5.0">SL4.0 vs SL5.0</Option>
                                </OptGroup>
                                <OptGroup label="reverse">
                                    <Option value="SL5.0__v__SL2.4">SL5.0 vs SL2.4</Option>
                                    <Option value="SL5.0__v__SL4.0">SL5.0 vs SL4.0</Option>
                                </OptGroup> 
                                
                            </Select>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" block>
                                Convert
                            </Button>
                        </Form.Item>
                    </Col>
                    <Col span={9}>
                        <Form.Item name="output_ids" label="GeneIDs Output">
                            <Input.TextArea rows="20" allowClear placeholder="output result GeneIDs"  />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }
}

export default IdConverter